import { useParams } from '@tanstack/react-router';
import { useCallback } from 'react';

import { useZero } from '@/lib/zero';
import { useUser } from '@/services/user';

export function useCommentResolution() {
  const z = useZero();
  const { user } = useUser();
  const { owner, repo, number } = useParams({ from: '/_authed/_layout/$owner/$repo/pull/$number' });

  const resolveComment = useCallback(
    async (commentId: number) => {
      if (!user) {
        throw new Error('User not authenticated');
      }

      await z.mutate.ReviewCommentsTable.resolveComment({
        commentId,
        resolvedById: user.id,
        owner,
        repo,
        pullNumber: number,
      });
    },
    [z, user, owner, repo, number]
  );

  const unresolveComment = useCallback(
    async (commentId: number) => {
      await z.mutate.ReviewCommentsTable.unresolveComment({
        commentId,
        owner,
        repo,
        pullNumber: number,
      });
    },
    [z, owner, repo, number]
  );

  return {
    resolveComment,
    unresolveComment,
  };
}
